var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_171_12290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 4.66663H11.9998C12.4376 4.66663 12.871 4.75285 13.2754 4.92036C13.6799 5.08788 14.0473 5.33341 14.3569 5.64294C14.6664 5.95247 14.9119 6.31993 15.0794 6.72435C15.247 7.12877 15.3332 7.56222 15.3332 7.99996C15.3332 8.4377 15.247 8.87115 15.0794 9.27557C14.9119 9.67999 14.6664 10.0475 14.3569 10.357C14.0473 10.6665 13.6799 10.912 13.2754 11.0796C12.871 11.2471 12.4376 11.3333 11.9998 11.3333H9.99984M5.99984 11.3333H3.99984C3.5621 11.3333 3.12864 11.2471 2.72423 11.0796C2.31981 10.912 1.95234 10.6665 1.64281 10.357C1.01769 9.73186 0.666504 8.88401 0.666504 7.99996C0.666504 7.1159 1.01769 6.26806 1.64281 5.64294C2.26794 5.01782 3.11578 4.66663 3.99984 4.66663H5.99984",
    stroke: "#FFFDFC",
    strokeWidth: 1.45455,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 8H10.6668",
    stroke: "#FFFDFC",
    strokeWidth: 1.45455,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_171_12290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkWhite);
export default __webpack_public_path__ + "static/media/link-white.62bc3ec8ff349dc27af2363be8f4d311.svg";
export { ForwardRef as ReactComponent };